export { FunzTabsComponent } from './funz-tabs';
